export default __webpack_public_path__ + "static/media/user-solid.9d9332a6.svg";